import { i18n } from '@lingui/core';
import { t } from '@lingui/macro';
import classnames from 'classnames';
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { onChangeLisboaZonesFilter } from '../../../ac/onChangeMapFilters';
import { ReactComponent as CircleLegend } from '../../../assets/images/circle.svg';
import { LISBOA_ZONES_FILTER } from '../../../constants/filterStyles';
import { getStyleFilterItems } from '../../../constants/filterStylesResolver';
import { withDisplayedLayersCheck } from '../../../HOC/withDisplayedLayersCheck';
import styles from '../FilterSidebar.module.css';

const LisboaZonesFiltersComponent = ({
    mapFilters,
    onChangeLisboaZonesFilter,
}) => {
    const { style, styleKey, reduxPath } = LISBOA_ZONES_FILTER;
    // ✅ Получаем items из стиля через resolver
    const items = getStyleFilterItems(style, styleKey);

    return (
        <div>
            <div className={styles.legHead}>{i18n._(LISBOA_ZONES_FILTER.title)}:</div>
            <div className={styles.checkboxIconGrid}>
                {
                    items.map(({ value, label, color }) => (
                        <Fragment key={value}>
                            <CircleLegend
                                fill={color}
                                width='2vw'
                                height='2vw'
                                opacity='0.8'
                            />
                            <label htmlFor={label.id}>{i18n._(label)}</label>
                            <div>
                                <label className={styles.switch}>
                                    <input
                                        type='checkbox'
                                        name='LisboaZonesStatuses'
                                        id={value}
                                        checked={mapFilters[reduxPath].includes(value)}
                                        value={value}
                                        onChange={onChangeLisboaZonesFilter}
                                    />
                                    <span className={classnames(styles.sliderRound, styles.slider)} />
                                </label>
                            </div>
                        </Fragment>
                    ))
                }
            </div>
            <br/>
            {/* <div className={styles.dataDescription}>Данные из таблицы public.parkings</div> */}
        </div>
    );
};
const mapStateToProps = ({ mapFilters: { LisboaZonesStatuses } }) => ({
    mapFilters: { LisboaZonesStatuses },
});
const ConnectedComponent = connect(mapStateToProps, { onChangeLisboaZonesFilter })(LisboaZonesFiltersComponent);

export const LisboaZonesFilter = withDisplayedLayersCheck(ConnectedComponent, t`Зоны ограничений в Лиссабоне`);
